import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, RadioGroup, Radio, FormControlLabel, Typography } from '@mui/material';

import { RootState } from '../../../reducers';
import { setMemberBudget } from '../../../store/memberBudget.slice';
import classes from '../Styles';
import { copyObject } from '../../../utils/common';
import CurrencyInput from '../../Shared/CurrencyInput';

const MedicineExpenses = () => {
    const dispatch = useAppDispatch();
    const { memberBudget } = useSelector((state: RootState) => state.memberBudget);

    const handleOnChangeFoodSource = (val: any, index: number) => {
        let memberBudgetData = copyObject(memberBudget);
        memberBudgetData.MedicineExpense.Expenses[index].Amount = val;
        dispatch(setMemberBudget(memberBudgetData));
    };

    const handleOnChangeRadio = (val: string, propName: string) => {
        let memberBudgetData = copyObject(memberBudget);
        memberBudgetData.MedicineExpense[propName] = val;
        dispatch(setMemberBudget(memberBudgetData));
    };

    return (
        <TableContainer component={Paper} sx={classes.budgetFormTable}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body1" component="label">
                                Medicines <small>(Over the counter meds)</small>
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {memberBudget.MedicineExpense?.Expenses?.map((medicineExpense, index) => (
                        <TableRow key={`medicine-expenses-${index}`} hover>
                            <TableCell scope="row">
                                <Grid container spacing={2}>
                                    <Grid size={4} display="flex" alignItems="center">
                                        <span>{medicineExpense.Name}</span>
                                    </Grid>
                                    <Grid size={4}>
                                        <CurrencyInput
                                            size="small"
                                            value={medicineExpense.Amount}
                                            name="Amount"
                                            onChange={(e) => handleOnChangeFoodSource(e.target.value, index)}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow hover>
                        <TableCell scope="row">
                            <Grid container spacing={2}>
                                <Grid size={4} display="flex" alignItems="center">
                                    <span>Do you have co-pays?</span>
                                </Grid>
                                <Grid size={4}>
                                    <RadioGroup
                                        row
                                        name="DoYouHaveCoPays"
                                        value={memberBudget.MedicineExpense.DoYouHaveCoPays}
                                        onChange={(e) => handleOnChangeRadio(e.target.value, e.target.name)}
                                    >
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MedicineExpenses;
